import { makeStyles } from 'tss-react/mui';

interface IUseCloseBtnStylesProps {
  isAbsolute?: boolean;
}

export const useCloseBtnStyles = makeStyles<IUseCloseBtnStylesProps>()(
  (theme, { isAbsolute }) => ({
    root: {
      position: isAbsolute ? 'absolute' : undefined,
      width: 36,
      height: 36,
      color: theme.palette.text.secondary,
      transition: theme.transitions.create(['background-color', 'color']),

      '&:hover': {
        color: theme.palette.text.primary,
      },
    },

    icon: {
      width: 24,
      height: 24,
    },
  }),
);
